// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__37d9v","title":"Header_title__3CjxR","left":"Header_left__3aENS","clinicName":"Header_clinicName__3pdYi"};